import React from 'react'
import BaseModal from "components/BaseModal";
import { Button,Table } from 'antd';
import ModalUtil from "utils/modalUtil";
import _ from "lodash";
import { CellRenderers } from 'utils/tableUtils';


function ComparisonModal({column,data}) {   

    const columnData = column instanceof Array && column.length ? column.join(', ') : CellRenderers.VALUE_OR_NA(column);

    const compareData = () =>{
        const { Column } = Table;
        const cweArray =  _.isArray(data.cwe) ? data.cwe : data.cwe.split(',');
        const ruleArray = _.isArray(data.ruleKey) ? data.ruleKey : data.ruleKey.split(',');
        const columnData = cweArray.map((cwe,i)=>{
            const rule = ruleArray[i];
            return { cwe, rule};
        });

        ModalUtil.show({
            content: (
                <BaseModal modalProps={{footer: null}}>
                 <Table dataSource={columnData}  pagination={false} scroll={{y:480}}>
                    <Column title="CWE" width='50%' align='center' dataIndex="cwe" key="cwe" />
                    <Column title="AMC Rule" width='50%' align='center' dataIndex="rule" key="rulekey" />
                </Table>
                </BaseModal>
            ),
        })
    }

    return (
        <>
            {columnData}
            {columnData.length > 30 &&
                <Button type="link" 
                    onClick={compareData}> View Deatils 
                 </Button>}
        </>
    )
}

export default ComparisonModal
